var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "#7760AB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8844 17.7727L15.7146 12.0562C15.6706 12.0243 15.6186 12.0051 15.5644 12.0009C15.5102 11.9967 15.4559 12.0075 15.4074 12.0322C15.359 12.0569 15.3183 12.0945 15.2899 12.1409C15.2615 12.1873 15.2465 12.2406 15.2465 12.295V23.7046C15.2472 23.7587 15.2626 23.8116 15.2911 23.8577C15.3195 23.9037 15.3598 23.9412 15.4078 23.9662C15.4558 23.9912 15.5097 24.0027 15.5637 23.9995C15.6178 23.9963 15.6699 23.9785 15.7146 23.9481L23.8844 18.2409C23.9204 18.2134 23.9495 18.1779 23.9695 18.1374C23.9895 18.0968 24 18.0521 24 18.0068C24 17.9616 23.9895 17.9169 23.9695 17.8763C23.9495 17.8357 23.9204 17.8003 23.8844 17.7727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.746d8867f67fd8f97d5a6b41b3947b1c.svg";
export { ForwardRef as ReactComponent };